/**
 * Configuración de campos para edición masiva de Cámaras Hanwha.
 *
 * Cada campo define:
 * - key:          Clave del campo en el payload (ej: 'id_center')
 * - label:        Clave i18n para la etiqueta
 * - type:         Tipo de campo ('select' | 'text')
 * - optionsKey:   Nombre de la prop de opciones en catalogOptions
 * - reduce:       Función para extraer el valor del v-select
 * - optionLabel:  Propiedad del label en las opciones (default: 'label')
 * - clearable:    Si el campo permite limpiar la selección
 * - cols:         Columnas de bootstrap (grid)
 *
 * Los campos booleanos (rtsp_available, is_fisheye, send_to_seproban) se
 * modelan como 'select' contra el catálogo 'booleanOptions' (Sí/No) porque el
 * modal genérico solo renderiza select/text.
 */
export const BULK_EDIT_FIELDS = [
  {
    // Camera->DVR FK column is `id_hanwha_dvr` (relation `hanwha_dvr`), not `id_dvr`.
    key: "id_hanwha_dvr",
    label: "hanwha_dvr.title",
    type: "select",
    optionsKey: "dvrOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "id_tenant",
    label: "tenants.title",
    type: "select",
    optionsKey: "tenantOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "id_center",
    label: "centers.title",
    type: "select",
    optionsKey: "centerOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "id_sector",
    label: "sectors.title",
    type: "select",
    optionsKey: "sectorOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "id_unit",
    label: "unit.title",
    type: "select",
    optionsKey: "unitOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "id_device_tag",
    label: "device_tag.title",
    type: "select",
    optionsKey: "deviceTagOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "rtsp_available",
    label: "camera_proxy.rtsp_available",
    type: "select",
    optionsKey: "booleanOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "is_fisheye",
    label: "hanwha_camera.fisheye",
    type: "select",
    optionsKey: "booleanOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
  {
    key: "send_to_seproban",
    label: "camera_proxy.send_to_seproban",
    type: "select",
    optionsKey: "booleanOptions",
    reduce: (val) => val.value,
    clearable: true,
    cols: 6,
  },
];

export const BULK_EDIT_ENDPOINT = "v1/hanwha/camera/bulk-update";

// GET endpoint for batch status polling ({endpoint}/{batch_id}).
export const BULK_EDIT_BATCH_STATUS_ENDPOINT = "v1/hanwha/camera/batches";

// Ids array key in the bulk-update payload. Backend expects
// { id_cameras: [...], filters: {...}, data: {...} } for manual selection.
export const BULK_EDIT_IDS_KEY = "id_cameras";
